import {Config} from '@/config';
import {cacheObservableData, catchUnathorized} from './decorators';
import {BaseApi} from './BaseApi';
import {DateTime} from 'luxon';
import {of} from 'rxjs';
import {HeroesVersion} from '@/api/HeroesVersion';

export const ReportOption = {
  Colors: 'colors',
  Fractions: 'fractions',
  Results: 'results',
  Heroes: 'heroes',
  Templates: 'templates',
};

class RatingApi extends BaseApi {
  public buildApiUrl(path: string) {
    return `${Config.ratingApiEndpoint}/rating/ajax.php?${path}`;
  }

  public getApiToken() {
    const w = (window as any);
    return typeof w.getRatingApiAccessToken === 'function' ? w.getRatingApiAccessToken() : null;
  }

  public getLatestRatingStartTime$() {
    return of(DateTime.local().toUTC().minus({years: 1}).toLocaleString(DateTime.DATE_SHORT));
  }

  @catchUnathorized()
  @cacheObservableData()
  public getUnconfirmedReports$(heroesVersion: HeroesVersion) {
    return this.getJSON(`action=get_unconfirmed_reports&h=${heroesVersion}`);
  }

  @catchUnathorized()
  @cacheObservableData()
  public getRating$(includeAll = false) {
    const all = (includeAll ? 'true' : 'false');
    return this.getJSON(`action=get_rating&all=${all}`);
  }

  @catchUnathorized()
  @cacheObservableData()
  public getUserProfile$(userId: number) {
    return this.getJSON(`action=get_user_profile&user=${userId}`);
  }

  @catchUnathorized()
  @cacheObservableData()
  public getReportOptions$() {
    return this.getJSON(`action=get_report_options`);
  }

  @catchUnathorized()
  @cacheObservableData()
  public getRatingLastUpdate$() {
    return this.getJSON(`action=get_rating_last_update`);
  }
}

export const ratingApi = new RatingApi();
